import { __rest } from "tslib";
import React, { useRef, useState, useEffect } from 'react';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import { apiHolder as api } from 'api';
import classnames from 'classnames';
import style from './editor.module.scss';
const defaultColors = [
    {
        value: 'rgba(0, 0, 0, 1)',
    },
    {
        value: 'rgba(244, 1, 7, 1)',
    },
    {
        value: 'rgba(247, 153, 6, 1)',
    },
    {
        value: 'rgba(254, 255, 4, 1)',
    },
    {
        value: 'rgba(152, 250, 28, 1)',
    },
    {
        value: 'rgba(109, 222, 255, 1)',
    },
    {
        value: 'rgba(64, 62, 214, 1)',
    },
    {
        value: 'rgba(237, 64, 253, 1)',
    },
    {
        value: 'rgba(233, 233, 233, 1)',
    },
    {
        value: 'rgba(123, 123, 123, 1)',
    },
    {
        value: 'rgba(250, 200, 184, 1)',
    },
    {
        value: 'rgba(252, 225, 178, 1)',
    },
    {
        value: 'rgba(253, 242, 204, 1)',
    },
    {
        value: 'rgba(217, 234, 211, 1)',
    },
    {
        value: 'rgba(224, 248, 255, 1)',
    },
    {
        value: 'rgba(207, 199, 244, 1)',
    },
    {
        value: 'rgba(253, 228, 255, 1)',
    },
    {
        value: 'rgba(217, 217, 217, 1)',
    },
    {
        value: 'rgba(92, 92, 92, 1)',
    },
    {
        value: 'rgba(233, 152, 154, 1)',
    },
    {
        value: 'rgba(249, 184, 77, 1)',
    },
    {
        value: 'rgba(252, 229, 154, 1)',
    },
    {
        value: 'rgba(172, 220, 126, 1)',
    },
    {
        value: 'rgba(133, 213, 229, 1)',
    },
    {
        value: 'rgba(140, 123, 233, 1)',
    },
    {
        value: 'rgba(238, 148, 247, 1)',
    },
    {
        value: 'rgba(196, 196, 196, 1)',
    },
    {
        value: 'rgba(51, 51, 51, 1)',
    },
    {
        value: 'rgba(224, 102, 102, 1)',
    },
    {
        value: 'rgba(247, 141, 0, 1)',
    },
    {
        value: 'rgba(251, 218, 104, 1)',
    },
    {
        value: 'rgba(135, 193, 31, 1)',
    },
    {
        value: 'rgba(76, 194, 238, 1)',
    },
    {
        value: 'rgba(63, 73, 186, 1)',
    },
    {
        value: 'rgba(208, 65, 225, 1)',
    },
    {
        value: 'rgba(157, 158, 158, 1)',
    },
    {
        value: 'rgba(38, 38, 38, 1)',
    },
    {
        value: 'rgba(204, 0, 0, 1)',
    },
    {
        value: 'rgba(231, 82, 0, 1)',
    },
    {
        value: 'rgba(249, 183, 3, 1)',
    },
    {
        value: 'rgba(103, 143, 1, 1)',
    },
    {
        value: 'rgba(49, 137, 251, 1)',
    },
    {
        value: 'rgba(39, 65, 178, 1)',
    },
    {
        value: 'rgba(164, 26, 212, 1)',
    },
];
const storeApi = api.api.getDataStoreApi();
function convertToRgba(color) {
    if (color.startsWith('#')) {
        let r = parseInt(color.substring(1, 3), 16);
        let g = parseInt(color.substring(3, 5), 16);
        let b = parseInt(color.substring(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, 1)`;
    }
    else if (color.startsWith('rgba')) {
        return color;
    }
    else if (color.startsWith('rgb')) {
        let values = color.match(/\d+/g);
        return `rgba(${values[0]}, ${values[1]}, ${values[2]}, 1)`;
    }
    else {
        let div = document.createElement('div');
        div.style.color = color;
        document.body.appendChild(div);
        let style = window.getComputedStyle(div);
        let rgb = style.color;
        document.body.removeChild(div);
        return convertToRgba(rgb);
    }
}
const HOCColor = (Component) => {
    const EdColor = (props) => {
        const { ref, onEditCreated } = props, rest = __rest(props, ["ref", "onEditCreated"]);
        const [editorInstance, seteditorInstance] = useState(null);
        const [visible, setVisible] = useState(false);
        const [colorList, setColorList] = useState(defaultColors);
        const [selectColor, setSelectColor] = useState('');
        const [defaultColor, setDefaultColor] = useState('rgb(0, 0, 0)');
        const [tipPos, setTipPos] = useState({
            top: 0,
            left: 0,
        });
        const setVisibleRef = useRef(setVisible);
        const setTipPosRef = useRef(setTipPos);
        setVisibleRef.current = setVisible;
        setTipPosRef.current = setTipPos;
        const colorAction = button => {
            let elem = document.querySelector('.lx-color-btn');
            while (elem) {
                if (elem.className.includes('tox-toolbar__group')) {
                    break;
                }
                elem = elem.parentElement;
            }
            const elemRect = elem.getBoundingClientRect();
            setVisibleRef.current(true);
            setTipPosRef.current({
                top: elemRect.top + 40,
                left: elemRect.left,
            });
        };
        const editorSetup = ed => {
            seteditorInstance(ed);
            onEditCreated(ed);
        };
        useEffect(() => {
            if (visible && editorInstance) {
                const fontColor = editorInstance.queryCommandValue('ForeColor');
                setSelectColor(convertToRgba(fontColor));
            }
        }, [visible]);
        useEffect(() => {
            const dcolor = storeApi.getSync('defaultColor').data;
            if (dcolor) {
                setDefaultColor(dcolor);
            }
        }, []);
        const setDefaultColorCl = () => {
            if (colorList.every(i => i.value !== selectColor))
                return;
            storeApi.put('defaultColor', selectColor);
            setDefaultColor(selectColor);
        };
        const selectColorCl = color => {
            const value = color.value;
            if (!editorInstance)
                return;
            setSelectColor(value);
            if (value === 'remove') {
                editorInstance.execCommand('mceRemoveTextcolor', 'forecolor');
                editorInstance.fire('TextColorChange', { name: 'forecolor', color: 'rgba(38, 42, 51, 0.9)' });
            }
            else {
                editorInstance.execCommand('mceApplyTextcolor', 'forecolor', value);
                editorInstance.fire('TextColorChange', { name: 'forecolor', color: value });
            }
            setVisible(false);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, rest, { ref: ref, colorAction: colorAction, onEditCreated: editorSetup })),
            React.createElement(LxPopover, { top: tipPos.top, left: tipPos.left, resetStyle: { zIndex: 999 }, visible: visible, setVisible: setVisible, acceptTopBottom: true },
                React.createElement("div", { className: classnames(style.colorBoxWrap, style.fontCommaBoxWrap) },
                    React.createElement("div", { className: classnames(style.colorBox) },
                        React.createElement("div", { title: "\u79FB\u9664\u989C\u8272", onClick: () => {
                                selectColorCl({ value: 'remove' });
                            }, className: classnames(style.toxSwatch, style.toxSwatchRemove, 'tox-swatch--remove') },
                            React.createElement("svg", { width: "24", height: "24" },
                                React.createElement("path", { stroke: "red", "stroke-width": "2", d: "M21 3L3 21", "fill-rule": "evenodd" }))),
                        colorList.map((color, index) => (React.createElement("div", { className: classnames(style.toxSwatch), style: { backgroundColor: color.value }, onClick: () => {
                                selectColorCl(color);
                            } }, selectColor === color.value && (React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React.createElement("path", { d: "M1.25 4L3.75 6.625L8.75 1.375", stroke: index % 9 === 0 ? '#fff' : '#3F465C', "stroke-width": "1.2", "stroke-linecap": "round", "stroke-linejoin": "round" }))))))),
                    React.createElement("div", { className: classnames(style.defaultCol) },
                        "\u9ED8\u8BA4\uFF1A ",
                        React.createElement("div", { className: classnames(style.toxSwatch), style: { backgroundColor: defaultColor } })),
                    React.createElement("div", { className: classnames(style.setDefaultCol, colorList.every(i => i.value !== selectColor) && 'disabled'), onClick: setDefaultColorCl }, "\u5C06\u5F53\u524D\u989C\u8272\u8BBE\u4E3A\u9ED8\u8BA4")))));
    };
    return React.forwardRef((props, ref) => React.createElement(EdColor, Object.assign({}, props, { ref: ref })));
};
export default HOCColor;
